// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-device-width: 768px) {
  form button {
    width: auto;
  }
}
.reset-phone-text {
  max-width: 300px;
}

.mobile-container {
  min-height: 5rem;
}
@media only screen and (max-device-width: 768px) {
  .mobile-container {
    min-height: 6rem;
  }
}

.message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.message-container .verification-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 274px;
}
.message-container .verification-container h4 {
  text-align: left;
}
.message-container .verification-container .custom-row {
  display: flex;
  text-align: center;
  align-items: center;
}
.message-container .verification-container .custom-row .icon-container {
  display: flex;
  flex-direction: column;
}
.message-container .code-receiver-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  line-height: 20px;
  padding: 10px 0px 5px;
  width: 274px;
}
.message-container .code-receiver-container a {
  display: flex;
  margin-left: auto;
}

.custom-row {
  line-height: 20px;
  display: flex;
  padding: 10px 0px;
}
.custom-row p {
  text-align: justify;
  padding-left: 5px;
}

.padding-bottom-5 {
  padding-bottom: 5px;
  align-self: flex-start;
}

a {
  cursor: pointer;
}

h4 {
  font-weight: 900;
}

p,
h3,
h4 {
  margin: 0 !important;
}

p.spacer-5 {
  margin-top: 5px !important;
}

ion-icon[name*=alert-circle-outline] {
  color: #d0021b;
  font-size: 1em;
}
ion-icon[name*=lock] {
  color: green;
  height: 2.5em;
  width: 2.5em;
}

.input-icon-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-icon-icon ion-icon {
  font-size: 2rem;
  align-items: center;
}

ion-grid {
  margin: 0px 80px;
}
@media screen and (max-width: 576px) {
  ion-grid {
    margin: 10px;
  }
}
ion-grid ion-list {
  padding: 0px;
}
ion-grid .password-container .password-input {
  width: 274px;
}
ion-grid .resend-class {
  display: inline-flex;
  width: 274px;
}
ion-grid .code-sent-row {
  display: grid;
  justify-content: center;
}
ion-grid .text-box-row {
  display: grid;
  justify-items: center;
}
ion-grid .resend-code-msg {
  background: transparent;
  border: 1px solid var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/validate-pin/validate-pin.component.scss"],"names":[],"mappings":"AAAA;EAEI;IACE,WAAA;EAAJ;AACF;AAIA;EACE,gBAAA;AAFF;;AAKA;EAIE,gBAAA;AALF;AAEE;EADF;IAEI,gBAAA;EACF;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAAI;EACE,gBAAA;AAEN;AAAI;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AAEN;AADM;EACE,aAAA;EACA,sBAAA;AAGR;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AAAJ;AACI;EACE,aAAA;EACA,iBAAA;AACN;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;AADF;AAEE;EACE,mBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,sBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;;;EAGE,oBAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAKE;EACE,cAAA;EACA,cAAA;AAFJ;AAKE;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAHJ;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAKE;EACE,eAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;AAKE;EAFF;IAGI,YAAA;EAFF;AACF;AAIE;EACE,YAAA;AAFJ;AAMI;EACE,YAAA;AAJN;AAQE;EACE,oBAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,uBAAA;AAPJ;AAUE;EACE,aAAA;EACA,qBAAA;AARJ;AAWE;EACE,uBAAA;EACA,4CAAA;AATJ","sourcesContent":["@media only screen and (max-device-width: 768px) {\n  form {\n    button {\n      width: auto;\n    }\n  }\n}\n\n.reset-phone-text {\n  max-width: 300px;\n }\n\n.mobile-container {\n  @media only screen and (max-device-width: 768px) {\n    min-height: 6rem;\n  }\n  min-height: 5rem;\n}\n\n.message-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  .verification-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 274px;\n    h4 {\n      text-align: left;\n    }\n    .custom-row {\n      display: flex;\n      text-align: center;\n      align-items: center;\n      .icon-container {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  .code-receiver-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    line-height: 20px;\n    padding: 10px 0px 5px;\n    width: 274px;\n    a {\n      display: flex;\n      margin-left: auto;\n    }\n  }\n}\n\n.custom-row {\n  line-height: 20px;\n  display: flex;\n  padding: 10px 0px;\n  p {\n    text-align: justify;\n    padding-left: 5px;\n  }\n}\n\n.padding-bottom-5 {\n  padding-bottom: 5px;\n  align-self: flex-start;\n}\n\na {\n  cursor: pointer;\n}\n\nh4 {\n  font-weight: 900;\n}\n\np,\nh3,\nh4 {\n  margin: 0 !important;\n}\n\np.spacer-5 {\n  margin-top: 5px !important;\n}\n\nion-icon {\n  &[name*=\"alert-circle-outline\"] {\n    color: #d0021b;\n    font-size: 1em;\n  }\n\n  &[name*=\"lock\"] {\n    color: green;\n    height: 2.5em;\n    width: 2.5em;\n  }\n}\n\n.input-icon-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ion-icon {\n    font-size: 2rem;\n    align-items: center;\n  }\n}\n\nion-grid {\n  margin: 0px 80px;\n  @media screen and (max-width: 576px) {\n    margin: 10px;\n  }\n\n  ion-list {\n    padding: 0px;\n  }\n\n  .password-container {\n    .password-input {\n      width: 274px;\n    }\n  }\n\n  .resend-class {\n    display: inline-flex;\n    width: 274px;\n  }\n\n  .code-sent-row {\n    display: grid;\n    justify-content: center;\n  }\n\n  .text-box-row {\n    display: grid;\n    justify-items: center;\n  }\n\n  .resend-code-msg {\n    background: transparent;\n    border: 1px solid var(--ion-color-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
